<template>
  <CockpitCard cardType="fullscreen" class="w-full h-full relative">
    <AlarmInfo
      class="absolute top-0px"
      :class="rightVis ? ' right-420px' : 'right-40px'"
    ></AlarmInfo>
    <PlatformLeft
      class="w-367px h-[calc(100%-20px)] absolute left-10px top-10px"
      @showRight="showRight"
    ></PlatformLeft>
    <PlatformRight
      class="w-367px h-[calc(100%-20px)] absolute right-50px top-10px"
      v-if="rightVis"
      :platformRightData="platformRightData"
      @showDetail="showDetail"
    ></PlatformRight>
    <Detail
      class="left-500px top-120px fixed w-800px h-500px"
      v-if="detailVis"
      :detailData="detailData"
      @close="detailVis = false"
    ></Detail>
    <div
      class="h-[calc(100%-24px)] absolute top-12px left-377px rounded-10px"
      :class="this.rightVis ? 'w-[calc(100%-795px)]' : 'w-[calc(100%-420px)]'"
    >
      <div class="absolute top-10px left-10px" v-if="deviceNameTitle">
        <span class="text-hex-fff text-18px mr-10px">{{ deviceNameTitle }}</span>
        <el-button type="primary" @click="goHtHome">{{ $t('返回') }}</el-button>
      </div>
      <iframe
        ref="htFrame"
        src="/static/ht/htView.html"
        class="h-full w-full rounded-10px"
        @load="iframeOnload()"
      ></iframe>
    </div>
  </CockpitCard>
</template>

<script>
import {
  PlatformMonitorApi,
  ComputerApi,
  DeviceAlarmApi,
  RackApi,
  ExchangeBoardApi,
  PositionStationApi,
  CommunicationStationApi,
  RouterDeviceApi,
  MonitorDeviceApi,
} from '@wiz-api/huizhou2-business'
import { IOTDeviceApi } from '@wiz-api/iot-device-management'
// tools
import { cloneDeep } from 'lodash'
// components
import CockpitCard from '@/components/cockpit/CockpitCard'
import PlatformLeft from './components/PlatformLeft'
import PlatformRight from './components/PlatformRight'
import Detail from './components/Detail'
import AlarmInfo from './components/AlarmInfo'

const platformMonitorApi = new PlatformMonitorApi()
const deviceAlarmApi = new DeviceAlarmApi()
const computerApi = new ComputerApi()
const exchangeBoardApi = new ExchangeBoardApi()
const rackApi = new RackApi()
const positionStationApi = new PositionStationApi()
const communicationStationApi = new CommunicationStationApi()
const iOTDeviceApi = new IOTDeviceApi()
const routerDeviceApi = new RouterDeviceApi()
const monitorDeviceApi = new MonitorDeviceApi()
const sm = { skipCount: 0, maxResultCount: 999 }
export default {
  components: { CockpitCard, PlatformLeft, PlatformRight, Detail, AlarmInfo },
  data() {
    return {
      rightVis: false, // 右侧弹框
      detailVis: false, // 详情弹框
      platformRightData: {},
      detailData: {},
      getPrimitivesTimer: null,
      nodesList: {},
      htDrawingUrl: 'displays/3d-huizhou/Platform-monitoring.json',
      deviceNameTitle: '',
      computerList: [], // 服务器
      cabinetsList: [], // 机柜
      exchangeBoardList: [], // 交换机
      cameraList: [], // 摄像头
      accessList: [], // 门禁
      positionStation: [], // 定位基站
      fiveGList: [], // 5G
      routerList: [], // 路由器
      deviceOnlineRateList: [], // 设备在线率
      // 信息映射
      infoObj: {
        服务器: 'computer',
        交换机: 'exchangeBoard',
        定位基站: 'positionStation',
        机柜: 'rack',
        '5G基站': 'communicationStation',
        门禁: 'access',
        摄像头: 'camera',
      },
      // 获取状态的接口参数映射
      apiObj: {
        服务器: 'Server',
        交换机: 'ExchangeBoard',
        定位基站: 'PositioningBaseStations',
        机柜: 'Cabinets',
        '5G基站': 'CommunicationBaseStations',
        门禁: 'Access',
        摄像头: 'Camera',
      },
    }
  },
  methods: {
    showRight(props) {
      if (!this.rightVis) {
        this.rightVis = true
      }
      this.platformRightData = cloneDeep(props)
    },
    showDetail(props) {
      this.detailData = cloneDeep(props)
      this.detailVis = true
    },

    // ht加载事件？
    iframeOnload() {
      try {
        const $window = this.$refs.htFrame.contentWindow
        $window.init(this.htDrawingUrl)
        this.nodesList = $window.dataModel._dataMap
        this.getTag = $window.getTag
        this.setAttrById = $window.setAttrById
        this.drawCenter = $window.drawCenter
      } catch (error) {
        this.iframeOnload()
      }
    },
    // 获取tooltip数据
    async getToolTipData(code, deviceType) {
      const [err, res] = await platformMonitorApi.getDeviceRealTimeValue({
        code, // String | 设备编号
        deviceType, // String | 设备类型 服务器 交换机 机柜
      })
      if (!err) {
        return res
      }
      return []
    },
    // 获取颜色值
    getColor(value) {
      let color = ''
      const num = parseInt(value, 0)
      if (num >= 0 && num <= 60) {
        color = 'green'
      } else if (num > 60 && num <= 90) {
        color = 'yellow'
      } else {
        color = 'red'
      }
      return color
    },
    async handleSingleDevice(code, type, item) {
      const data = await this.getToolTipData(code, type)
      // 获取未读报警数
      const alarmCount = await this.getUnreadAlarmCount(item)
      let serveStr = ''
      if (data.length) {
        data.forEach((it) => {
          const setColor = it.split('：')
          let color = ''
          if (setColor[0] !== '平均负载') {
            color = this.getColor(setColor[1])
          }
          serveStr += `<div style="color:#fff;">${setColor[0]}：<span style="color:${color}">${setColor[1]}</span></div>`
        })
        serveStr += `<div style="color:red;">未读报警：<span style="color:red;">${alarmCount.count}</span></div>`
      }
      if (serveStr) {
        item.setToolTip(
          `<div style="position:absolute;top:0;left:0;background:#0b292f;padding:6px">${serveStr}</div>`
        )
      }
      // 设置状态（健康，异常，报警）
      await this.setStatus(item)
    },
    async setStatus(item) {
      const type = item._attrObject.type
      const data = await this.getUnreadAlarmCount(item)
      if (data && data.data) {
        const [err, res] = await monitorDeviceApi.getDeviceStatus({
          deviceId: data.data.id,
          deviceType: type,
        })
        if (!err && res) {
          if (res.data.status === 2) {
            this.setAttrById(item._id, { textBg: '#808b10' }) // 设置文本背景颜色-异常
          } else if (res.data.status === 3) {
            this.setAttrById(item._id, { textBg: '#5c1c19' }) // 设置文本背景颜色-报警
          }
          return res.data.online ? '在线' : '离线'
        }
      }
      return '在线'
    },
    async handlePrimitivesInfo(list) {
      if (!list.length) return
      for (let i = 0; i < list.length; i += 1) {
        const it = list[i]
        if (it._attrObject && it._attrObject.type && it._attrObject.code) {
          const pass = ['服务器', '机柜', '交换机'].includes(it._attrObject.type)
          if (pass) {
            // eslint-disable-next-line no-await-in-loop
            await this.handleSingleDevice(it._attrObject.code, it._attrObject.type, it)
          }
          this.handleTip(it._attrObject.type, it)
        }
      }
    },
    // 获取报警数量
    async getUnreadAlarmCount(item) {
      const code = item._attrObject.alarmCode
      let count = 0
      let data = null
      switch (item._attrObject.type) {
        case '服务器':
          data = this.computerList.find((i) => {
            return i.code === code
          })
          break
        case '机柜':
          data = this.cabinetsList.find((i) => {
            return i.code === code
          })
          break
        case '交换机':
          data = this.exchangeBoardList.find((i) => {
            return i.code === code
          })
          break
        case '门禁':
          data = this.accessList.find((i) => {
            return i.code === code
          })
          break
        case '摄像头':
          data = this.cameraList.find((i) => {
            return i.code === code
          })
          break
        case '定位基站':
          data = this.positionStation.find((i) => {
            return i.code === code
          })
          break
        default:
          break
      }
      if (data) {
        const [err, res] = await deviceAlarmApi.getAccessAlarmCount({
          deviceId: data.id,
        })
        if (!err) count = res.isReadCount
      }
      return { count, data }
    },
    // 门禁摄像头基站tip处理
    handleTip(name, item) {
      const des = ['门禁', '摄像头', '定位基站'].includes(name)
      if (!des) return
      const tip = this.deviceOnlineRateList.find((i) => {
        return i.deviceType === name
      })
      if (tip) {
        item.setToolTip(
          `<div style="position:absolute;top:0;left:0;background:#0b292f;padding:6px">
            <div style="color:#fff;">在线数：<span">${tip.onlineDevices}</span></div>
            <div style="color:#fff;">在线率：<span">${tip.onlineRate}</span></div>
          </div>`
        )
      }
    },
    // 二级tip图标处理
    levelTipHandle() {
      // 获取图元
      this.getPrimitivesTimer = setInterval(async () => {
        if (!_.isEmpty(this.nodesList)) {
          clearInterval(this.getPrimitivesTimer)
          const pelList = this.getTag()
          for (let i = 0; i < pelList.length; i += 1) {
            // eslint-disable-next-line no-await-in-loop
            const countObj = await this.getUnreadAlarmCount(pelList[i])
            // 设置状态（健康，异常，报警）
            // eslint-disable-next-line no-await-in-loop
            const status = await this.setStatus(pelList[i])
            pelList[i].setToolTip(
              `<div style="position:absolute;top:0;left:0;background:#0b292f;padding:6px">
                <div style="color:#fff;">状态：<span">${status}</span></div>
                <div style="color:red;">未读报警：<span">${countObj.count}</span></div>
             </div>`
            )
          }
        }
      }, 500)
    },
    goHtHome() {
      this.htDrawingUrl = this.$options.data().htDrawingUrl
      this.deviceNameTitle = ''
      this.iframeOnload()
      if (this.getPrimitivesTimer) clearInterval(this.getPrimitivesTimer)
    },
    // 获取服务器所有数据列表
    async getPrimitives() {
      const [err, res] = await computerApi.getList(sm)
      if (!err) this.computerList = res.items
    },
    // 获取机柜所有数据列表
    async getCabinets() {
      const [err, res] = await rackApi.getList(sm)
      if (!err) this.cabinetsList = res.items
    },
    // 获取交换机所有数据列表
    async getExchangeboard() {
      const [err, res] = await exchangeBoardApi.getList(sm)
      if (!err) this.exchangeBoardList = res.items
    },
    // 获取定位基站数据列表
    async getPositionList() {
      const [err, res] = await positionStationApi.getList(sm)
      if (!err) this.positionStation = res.items
    },
    // 获取5G基站数据列表
    async getFiveGList() {
      const [err, res] = await communicationStationApi.getList(sm)
      if (!err) this.fiveGList = res.items
    },
    // 获取摄像头数据列表
    async getCamera() {
      const [cameraErr, cameraRes] = await iOTDeviceApi.getDeviceWithDetailPageList({
        deviceTypeCode: 'Camera',
        ...sm,
      })
      if (!cameraErr) this.cameraList = cameraRes.items
    },
    // 获取门禁数据列表
    async getAccess() {
      const [cameraErr, cameraRes] = await iOTDeviceApi.getDeviceWithDetailPageList({
        deviceTypeCode: 'AccessControl',
        ...sm,
      })
      if (!cameraErr) this.accessList = cameraRes.items
    },
    // 获取路由器列表数据
    async getRouterList() {
      const [err, res] = await routerDeviceApi.getList(sm)
      if (!err) this.routerList = res.items
    },
    // 获取设备在线率（门禁，摄像头，定位基站）
    async getDeviceOnlineRate() {
      const [err, res] = await platformMonitorApi.getDeviceStatistics()
      if (!err && res) {
        this.deviceOnlineRateList = res.map((it) => {
          if (it.deviceType === '监控') it.deviceType = '摄像头'
          if (it.deviceType === '通信基站') it.deviceType = '5G'
          return it
        })
      }
    },
    // 获取图元信息
    getAllIcon() {
      this.getPrimitivesTimer = setInterval(() => {
        if (!_.isEmpty(this.nodesList)) {
          clearInterval(this.getPrimitivesTimer)
          const arrData = this.getTag()
          this.handlePrimitivesInfo(arrData)
        }
      }, 500)
    },
    // 获取双击图标信息
    async getDoubleClickInfo(data) {
      if (data._attrObject.alarmCode && data._attrObject.type) {
        const devObj = {
          deviceName: data._attrObject.type,
          deviceType: this.infoObj[data._attrObject.type],
        }
        const info = await this.getUnreadAlarmCount(data)
        this.showDetail({ ...info, ...devObj })
      }
    },
    toggleDevice(e) {
      try {
        const data = JSON.parse(e.data)
        console.log('🚀 ~ window.addEventListener ~ data:', data)
        if (data.type === 'doubleClickIcon') {
          if (data.data._displayName === 'camera') {
            this.htDrawingUrl = 'displays/3d-huizhou/cameraDrawings.json'
            this.deviceNameTitle = '摄像头'
            this.iframeOnload()
            this.levelTipHandle(this.cameraList)
          } else if (data.data._displayName === 'access') {
            this.htDrawingUrl = 'displays/3d-huizhou/accessDraw.json'
            this.deviceNameTitle = '门禁'
            this.iframeOnload()
            this.levelTipHandle(this.accessList)
          } else if (data.data._displayName === 'position') {
            this.htDrawingUrl = 'displays/3d-huizhou/positionDraw.json'
            this.deviceNameTitle = '定位基站'
            this.iframeOnload()
            this.levelTipHandle(this.positionStation)
          } else if (data.data._displayName === '5G') {
            this.htDrawingUrl = 'displays/3d-huizhou/5Gdraw.json'
            this.deviceNameTitle = '5G基站'
            this.iframeOnload()
            // this.getAllIcon(this.fiveGList, '5G') // 暂时屏蔽
          } else {
            this.getDoubleClickInfo(data.data)
          }
        }
      } catch (error) {
        //
      }
    },
  },
  created() {
    this.getPrimitives()
    this.getCabinets()
    this.getExchangeboard()
    this.getDeviceOnlineRate()
    this.getCamera()
    this.getAccess()
    this.getPositionList()
    this.getFiveGList()
  },
  mounted() {
    this.getAllIcon()
    window.addEventListener('message', this.toggleDevice)
  },
  beforeDestroy() {
    if (this.getPrimitivesTimer) {
      clearInterval(this.getPrimitivesTimer)
    }
    window.removeEventListener('message', this.toggleDevice)
  },
  watch: {
    rightVis() {
      this.$nextTick(() => {
        this.drawCenter()
      })
    },
  },
}
</script>
